import { Navigate, Outlet } from "react-router-dom";
import { useOperator, useProfile } from "@/hooks";

export const RequireOperatorAccount = () => {
  const operator = useOperator();
  const profile = useProfile();

  if (!operator) throw new Error("Operator not set");
  if (!profile) throw new Error("Account not set");

  // Check if registration is complete
  const isRegisterComplete = profile.accountMetadata?.isRegisterComplete ?? false;

  if (!isRegisterComplete) {
    return <Navigate to="/onboarding/operator" replace />;
  }

  return <Outlet />;
};
